export class ReadReceiptsStatisticValuesDTO {

    name: string;

    value: number;
    
}
